// @core/api/endpoints/workflow/get_test_result.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestResultResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get test result
 * Retrieves a test result including per-node results, assertion outcomes, and coverage.
 */
export async function GetTestResult(
  test_result_id: string,
  options?: RequestOptions
): Promise<TestResultResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/test-results/:test_result_id`;
  requestPath = requestPath.replace(':test_result_id', encodeURIComponent(test_result_id));
  const requestOptions = options;
  return client.get<TestResultResponse>(requestPath, { ...requestOptions });
}
